import { render, staticRenderFns } from "./CoinsDetail.vue?vue&type=template&id=2148aaa7&scoped=true&"
import script from "./CoinsDetail.vue?vue&type=script&lang=js&"
export * from "./CoinsDetail.vue?vue&type=script&lang=js&"
import style0 from "./CoinsDetail.vue?vue&type=style&index=0&id=2148aaa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2148aaa7",
  null
  
)

export default component.exports